"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailAccountSmtpStateEnum = void 0;
var MailAccountSmtpStateEnum;
(function (MailAccountSmtpStateEnum) {
    MailAccountSmtpStateEnum["None"] = "N";
    MailAccountSmtpStateEnum["Error"] = "E";
    MailAccountSmtpStateEnum["Unauthorized"] = "U";
    MailAccountSmtpStateEnum["Authenticated"] = "A";
    MailAccountSmtpStateEnum["Connected"] = "C";
    MailAccountSmtpStateEnum["Connecting"] = "Cn";
    MailAccountSmtpStateEnum["Disconnected"] = "D";
})(MailAccountSmtpStateEnum = exports.MailAccountSmtpStateEnum || (exports.MailAccountSmtpStateEnum = {}));
